import React from 'react';
import LegalGVW from './MNOutput/LegalGVW';
import TruckImage from './MNOutput/TruckImage';
import AxleGroupWeights from './MNOutput/AxleGroupWeights';
import MaxWeights from './MNOutput/MaxWeights';
import BridgeWeightSelector from './MNOutput/BridgeWeightSelector';
import ConfigurationDetails from './MNOutput/ConfigurationDetails';

class MNOutput extends React.Component {
	constructor(props) {
		super(props)
		this.props.resetCurrentAxle(); // must reset axle, or redirecting to MNInput will immediately redirect back
	}
	
	render() {
		return (
			<div>
				<LegalGVW truck={this.props.truck}/>
				<TruckImage truck={this.props.truck} />
				<AxleGroupWeights truck={this.props.truck} />
				<MaxWeights truck={this.props.truck} />
				<BridgeWeightSelector truck={this.props.truck} />
				<ConfigurationDetails truck={this.props.truck} />
			</div>
		);
	}
}

export default MNOutput;


// WEBPACK FOOTER //
// ./src/Minnesota/MNOutput.js